// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"02a98ddc","342":"92d0c8b6","400":"84f377ca","488":"52f5cf22","821":"e64a407c","878":"88acf7e3"}[chunkId] + ".chunk.js";
};